export default __webpack_public_path__ + "static/media/mechanic-1.46b6dd79.jpg";